import { toDateInputValue, type DateFieldValue } from '@/utils/dateFields';

type RfiLogExportDateSource = {
  open_date?: DateFieldValue;
  due_date?: DateFieldValue;
};

export const getRfiLogExportDateDefaults = (
  rfiLog?: RfiLogExportDateSource | null,
) => ({
  date: toDateInputValue(rfiLog?.open_date),
  date_required: toDateInputValue(rfiLog?.due_date),
});
